"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("./Flex.js"));

var _Paper = _interopRequireDefault(require("./Paper.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils.js"));

var _String = _interopRequireDefault(require("./String.js"));

var _TableListModule = _interopRequireDefault(require("./TableList.module.scss"));

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Two-column table of key/value pairs
 */
class TableList extends _react.default.PureComponent {
  /**
   * State
   * 
   * @type {Object}
   */
  state = {
    /**
     * Ref to our `Table` root element
     *
     * @type {ReactRef}
     */
    tableRef: null
  };
  /**
   * Assign our table ref.
   *
   * @param {ReactRef} tableRef
   * @return {void}
   */

  assignTableRef = tableRef => this.setState({
    tableRef
  });
  /**
   * Component mounted.
   *
   * We need to set our dynamic CSS properties.
   *
   * @return {void}
   */

  componentDidMount() {
    this.updateCss();
  }
  /**
   * Component updated.
   *
   * We need to update dynamic CSS properties when controlling props change.
   *
   * @param {Object} prevProps
   * @param {Object} prevState
   * @return {void}
   */


  componentDidUpdate(prevProps, prevState) {
    const tableRef = prevState.tableRef !== this.state.tableRef;
    const labelsWidth = prevProps.labelsWidth !== this.props.labelsWidth;
    const needsCssUpdate = tableRef || labelsWidth;
    if (needsCssUpdate) this.updateCss();
  }
  /**
   * Render.
   * 
   * @return {ReactNode}
   */


  render() {
    const data = this.data;
    if (!data?.length && this.props.hiddenWhenEmpty) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
      px: 0,
      py: 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Table, {
        ref: this.assignTableRef,
        size: this.props.size,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.TableBody, {
          children: data.map((data, key) => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_core.TableRow, {
              className: _TableListModule.default.row,
              children: [this.renderCell( /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
                bold: true,
                str: data.label
              })), this.renderCell(data.content)]
            }, key);
          })
        })
      })
    });
  }
  /**
   * Render content into a table cell.
   *
   * @param {ReactNode|Array|String|Number} content
   * @return {ReactNode} `TableCell` with content
   */


  renderCell(content) {
    if (typeof content === "string" || typeof content === "number" || Array.isArray(content)) {
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        str: content
      });
    } else content = _ReactUtils.default.render(content);

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.TableCell, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, { ...this.props.CellFlexProps,
        gap: 0.5,
        children: content
      })
    });
  }
  /**
   * Update the values of all our monitored CSS props.
   * 
   * @return {void}
   */


  updateCss() {
    this.updateCssProp("columns", this.columns);
  }
  /**
   * Update the value of a CSS property.
   *
   * @param {String} prop
   * @param {String} val
   * @return {void}
   */


  updateCssProp(prop, val) {
    this.state.tableRef?.style?.setProperty?.(`--table-list-${prop}`, val);
  }
  /**
   * Get our CSS grid columns definition.
   * 
   * @return {String}
   */


  get columns() {
    return `${this.props.labelsWidth} ${this.props.valuesWidth}`;
  }
  /**
   * Get our data objects.
   *
   * @return {Array}
   */


  get data() {
    return this.props.data?.filter(data => !data.hidden);
  }

  static propTypes = {
    data: _propTypes.default.array,
    hiddenWhenEmpty: _propTypes.default.bool,
    labelsWidth: _propTypes.default.string,
    size: _propTypes.default.oneOf(["small", "medium"]),
    valuesWidth: _propTypes.default.string
  };
  static defaultProps = {
    hiddenWhenEmpty: true,
    labelsWidth: "24rem",
    size: "small",
    valuesWidth: "1fr"
  };
}

var _default = TableList;
exports.default = _default;